<div id="configure-sidebar" class="configure-sidebar-wrapper d-flex flex-column align-items-center align-items-sm-start">
  <ul class="nav nav-pills flex-column mb-0 align-items-center align-items-sm-start w-100" id="menu">
    @for (item of sidebarConfig; track item) {
    <li class="w-100" [ngClass]="{'active': activeId === item.activeClassId}" (click)="goToItem(item)">
      {{ item.title | translate }}
      <i class="float-end bi bi-chevron-right"></i>
    </li>
    }
  </ul>
</div>